module.exports = __webpack_public_path__ + "img/articulo41.af04f7a3.png";